<template>
  <div>
    <FlashMessage v-if="this.messages.text != ''" :message="this.messages" />
    <div class="flex">
      <SideBar />

      <div
        class="w-[90%] mx-auto lg:w-full lg:mr-10 mt-10 rounded-3xl overflow-y-auto heightfix"
        style="box-shadow: 0px 2px 30px 0px #01b0f926"
      >
        <div class="flex flex-col gap-5 pt-5 px-5 lg:px-10 py-10">
          <div class="w-full h-full py-5 flex flex-col gap-5">
            <div
              class="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4"
            >
              <div class="flex items-center gap-3">
                <div>
                  <h2 class="text-xl font-bold text-gray-800">
                    Team Members
                    <span
                      class="text-blue-600 text-sm font-medium ml-2 bg-blue-50 px-2 py-0.5 rounded-full"
                      >{{ count_list || 0 }}</span
                    >
                  </h2>
                  <p class="text-xs text-gray-400 mt-0.5">
                    Manage and monitor department users
                  </p>
                </div>
              </div>
              <router-link :to="{ name: 'AdminDashboards' }">
                <button
                  class="flex items-center gap-2 bg-gray-100 hover:bg-gray-200 text-gray-600 hover:text-gray-800 py-2 px-4 rounded-xl transition-all duration-200 text-sm font-medium"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    class="h-4 w-4"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M10 19l-7-7m0 0l7-7m-7 7h18"
                    />
                  </svg>
                  Back to Dashboard
                </button>
              </router-link>
            </div>

            <div
              class="flex flex-col md:flex-row justify-between items-start md:items-center gap-4"
            >
              <!-- Breadcrumb -->
              <div class="text-[#0085DB] font-medium">
                <ul class="breadcrumb flex flex-wrap items-center text-sm">
                  <li
                    v-for="(item, index) in b_value"
                    :key="index"
                    :class="{
                      'breadcrumb-item': !isActive(index),
                      'active-breadcrumb-item text-blue-600': isActive(index),
                    }"
                  >
                    <span
                      class="px-2"
                      :class="{
                        'breadcrumb-text text-gray-500 hover:text-blue-600 transition':
                          !isActive(index),
                      }"
                    >
                      <router-link :to="{ name: item.name }">{{
                        item.text
                      }}</router-link>
                    </span>
                    <span
                      v-if="index < b_value.length - 1"
                      class="breadcrumb-arrow text-gray-300 mx-1"
                    >
                      /
                    </span>
                  </li>
                </ul>
              </div>

              <!-- Search Bar -->
              <div class="relative w-full md:w-72">
                <div
                  class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    class="h-4 w-4 text-gray-400"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                    />
                  </svg>
                </div>
                <input
                  type="text"
                  v-model="searching"
                  @input="searchUserValue(1)"
                  placeholder="Search by name or email..."
                  class="w-full rounded-xl border border-gray-200 bg-gray-50 pl-10 pr-10 py-2.5 text-sm text-gray-700 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500 transition-all"
                />
                <button
                  v-if="searching"
                  @click="clearSearch"
                  class="absolute inset-y-0 right-0 pr-3 flex items-center"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    class="h-4 w-4 text-gray-400 hover:text-gray-600"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M6 18L18 6M6 6l12 12"
                    />
                  </svg>
                </button>
              </div>
            </div>

            <!-- Table Section -->
            <div v-if="departments.length > 0" class="mt-2">
              <div
                class="overflow-x-auto rounded-2xl border border-gray-200 bg-white shadow-sm"
              >
                <table class="min-w-full divide-y divide-gray-100">
                  <thead>
                    <tr class="bg-gray-100">
                      <th
                        class="px-5 py-4 text-center text-sm font-semibold rounded-l-xl text-textblues border-r border-gray-200"
                      >
                        <span class="flex items-center gap-1"> S.No </span>
                      </th>
                      <th
                        class="px-5 py-4 text-center text-sm font-semibold text-textblues border-r border-gray-200"
                      >
                        <span class="flex items-center gap-1"> Email </span>
                      </th>
                      <th
                        class="px-5 py-4 text-center text-sm font-semibold text-textblues border-r border-gray-200"
                      >
                        <span class="flex items-center gap-1">
                          Display name
                        </span>
                      </th>
                      <th
                        class="px-5 py-4 text-center text-sm font-semibold text-textblues border-r border-gray-200"
                      >
                        <span class="flex items-center gap-1"> Role </span>
                      </th>
                      <th
                        class="px-5 py-4 text-center text-sm font-semibold rounded-r-xl text-textblues"
                      >
                        <span class="flex items-center gap-1"> Status </span>
                      </th>
                    </tr>
                  </thead>

                  <tbody class="divide-y divide-gray-50">
                    <tr
                      v-for="(list, index) in departments"
                      :key="index"
                      class="hover:bg-blue-50/30 transition-all duration-150 group"
                    >
                      <td
                        class="px-5 py-3.5 text-sm text-gray-500 font-medium border-r border-gray-200"
                      >
                        <span
                          class="inline-flex items-center justify-center w-7 h-7 bg-gray-100 rounded-lg text-xs font-semibold text-gray-600 group-hover:bg-blue-100 group-hover:text-textblues transition"
                        >
                          {{ (currentPage - 1) * 10 + index + 1 }}
                        </span>
                      </td>

                      <td class="px-5 py-3.5 border-r border-gray-200">
                        <span class="font-medium text-gray-500 text-xs">{{
                          list.email || "---"
                        }}</span>
                      </td>

                      <td class="px-5 py-3.5 border-r border-gray-200">
                        <span
                          class="font-medium text-gray-500 text-xs capitalize"
                          >{{ list.display_name || "---" }}</span
                        >
                      </td>
                      <td class="px-5 py-3.5 border-r border-gray-200">
                       <span class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-gray-100 text-gray-600">
                        {{ list.permission || "User" }}
                      </span>
                      </td>

                      <td class="px-5 py-3.5">
                        <label
                          class="relative inline-flex items-center cursor-pointer group"
                        >
                          <input
                            type="checkbox"
                            class="sr-only peer"
                            :checked="list.is_active"
                            @change="handleToggle(list)"
                          />
                          <!-- Track -->
                          <div
                            :class="[
                              'w-11 h-6 rounded-full transition-all duration-300 ease-in-out',
                              'peer-checked:bg-green-500 peer-checked:shadow-md',
                              'bg-gray-300 shadow-inner',
                              'group-hover:scale-105 transition-transform',
                            ]"
                          ></div>
                          <!-- Knob -->
                          <div
                            :class="[
                              'absolute left-0.5 top-0.5 bg-white rounded-full transition-all duration-300 ease-in-out',
                              'w-5 h-5 shadow-md',
                              'peer-checked:translate-x-5 peer-checked:bg-white',
                              'group-active:scale-90',
                            ]"
                          ></div>
                          <!-- Status Text -->
                          <span
                            :class="[
                              'ml-3 text-xs font-medium transition-colors duration-200',
                              list.is_active
                                ? 'text-green-600'
                                : 'text-red-500',
                            ]"
                          >
                            {{ list.is_active ? "Active" : "Inactive" }}
                          </span>
                        </label>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <div class="mt-6">
                <Pagination
                  :totalPages="totalPages"
                  ref="paginationRef"
                  @page-changed="departmentget"
                />
              </div>
            </div>

            <!-- Empty State -->
            <div
              v-else
              class="flex flex-col items-center justify-center py-16 bg-gray-50 rounded-2xl"
            >
              <div
                class="w-20 h-20 bg-gray-100 rounded-full flex items-center justify-center mb-4"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="h-10 w-10 text-gray-400"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="1.5"
                    d="M20 13V6a2 2 0 00-2-2H6a2 2 0 00-2 2v7m16 0v5a2 2 0 01-2 2H6a2 2 0 01-2-2v-5m16 0h-2.586a1 1 0 00-.707.293l-2.414 2.414a1 1 0 01-.707.293h-3.172a1 1 0 01-.707-.293l-2.414-2.414A1 1 0 006.586 13H4"
                  />
                </svg>
              </div>
              <h3 class="text-lg font-semibold text-gray-700">
                No Departments Found
              </h3>
              <p class="text-sm text-gray-400 mt-1">
                Try adjusting your search or filter
              </p>
            </div>
            <!-- Popup -->
            <div
              v-if="showPopup"
              class="fixed bg-primary bg-opacity-30 top-0 left-0 right-0 bottom-0 z-50 flex items-center justify-center"
            >
              <div
                class="lg:w-[40%] 2xl:w-[30%] bg-white rounded-xl p-10 overflow-y-auto max-h-[600px]"
              >
                <div class="w-full flex flex-col relative rounded-2xl">
                  <div class="w-full flex flex-col gap-8">
                    <h1
                      v-if="this.checkbox_status == false"
                      class="font-bold text-sm text-red-400 text-center"
                    >
                      Do You Want To Deactivate This User
                      <span class="text-sm text-textblues">{{ dep_email }}</span
                      >?
                    </h1>
                    <h1
                      v-else
                      class="font-bold text-sm text-green-400 text-center"
                    >
                      Do You Want To Activate This User
                      <span class="text-sm text-textblues">{{ dep_email }}</span
                      >?
                    </h1>
                    <div class="flex items-center justify-center gap-5">
                      <button
                        @click="cancelToggle"
                        class="bg-blues  hover:bg-hover text-white rounded-xl text-sm font-semibold px-6 py-2"
                      >
                        No
                      </button>
                      <button
                        @click="confirmToggle"
                        class="bg-blues hover:bg-hover text-white rounded-xl text-sm font-semibold px-6 py-2"
                      >
                        Yes
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SideBar from "@/components/Admin/SideBar.vue";
import FlashMessage from "@/components/FlashMessage.vue";
import axios from "axios";
import { mapGetters } from "vuex";
import Pagination from "@/components/Pagination.vue";

export default {
  data() {
    return {
      //   loading: true,
      messages: {
        text: "",
        type: "null",
      },

      departments: [],

      count_list: "",
      currentPage: 1,
      totalPages: 1,
      perPage: 10,
      searching: "",

      showPopup: false,
      pendingItem: null,
      dep_email: "",
      checkbox_status: false,
    };
  },
  props: ["depart_id", "d_name"],
  components: {
    SideBar,
    FlashMessage,
    Pagination
  },
  async created() {
    this.b_value = [
      { text: "Dashboard", name: "AdminDashboards" },
      { text: "Department", name: "AdminDashboards" },
      { text: this.d_name },
    ];
    await this.departmentget(1);
  },

  computed: {
    ...mapGetters(["userInfo"]),
  },
  methods: {
    handleToggle(item) {
      if (item) {
        this.pendingItem = item;
        this.dep_email = item.email;
        this.showPopup = true;
        if (item.is_active == true) {
          this.checkbox_status = false;
        } else {
          this.checkbox_status = true;
        }
      }
    },
    cancelToggle() {
      this.pendingItem = null;
      this.showPopup = false;
    },
    confirmToggle() {
      if (this.pendingItem) {
        this.updateStatus(this.pendingItem, false);
        this.pendingItem = null;
        this.showPopup = false;
      }
    },

    async updateStatus(item) {
      let acceptsVal = {};
      if (item.is_active == true) {
        acceptsVal = {
          is_active: false,
        };
      } else {
        acceptsVal = {
          is_active: true,
        };
      }

      axios
        .put(
          `${process.env.VUE_APP_API}/profile/is-active/${item.user_id}/?Key=${this.userInfo.token_key}`,
          acceptsVal,
        )
        .then((response) => {
          if (response.data.status == 200) {
            this.messages = {
              text: response.data.message,
              type: "success",
            };
            console.log("successful");
          } else {
            this.messages = {
              text: " Event Faild",
              type: "error",
            };
            console.log("not successful");
          }
        })
        .catch((error) => {
          this.messages = {
            text: error.response.data.error,
            type: "error",
          };
        });

      setTimeout(() => {
        this.messages = {
          text: "",
          type: "null",
        };
        this.departmentget(1);
      }, 3000);
    },
    isActive(index) {
      return index === this.b_value.length - 1;
    },
    async departmentget(page) {
      this.currentPage = page;
      await axios
        .get(
          `${process.env.VUE_APP_API}/program-user-details-get/${this.depart_id}/?Key=${this.userInfo.token_key}&page=${page}`,
        )
        .then((res) => {
          if (res.data.data.status == 200) {
            this.departments = res.data.data.data;
            this.count_list = res.data.total;
            this.totalPages = res.data.total_page;
            this.current_page = res.data.current_page;
          }
        });
    },
    async searchUserValue(page) {
      this.currentPage = page;

      await axios
        .get(
          `${process.env.VUE_APP_API}/program-user-details-get/${this.depart_id}/?search=${this.searching}&Key=${this.userInfo.token_key}&page=${page}`,
        )
        .then((res) => {
          if (res.data.data.status == 200) {
            this.departments = res.data.data.data;
            this.count_list = res.data.total;
            this.totalPages = res.data.total_page;
            this.current_page = res.data.current_page;
          }
        });
    },
    clearSearch() {
      this.searching = "";
      this.departmentget(1);
    },
  },
};
</script>

<style scoped>
.heightfix {
  height: calc(100vh - 170px) !important;
}
</style>
